import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {BannerService} from "../../../../core/_services/banner.service";
import {UserService} from "../../../../core/_services/user.service";
import {Subscription} from "rxjs";
import {Role} from "../../../_models/role";
import {RoleService} from "../../../../core/_services/role.service";
import {UtilitiesService} from "../../../../core/_services/utilities.service";
import {User} from "app/shared/_models/user";

@Component({
  selector: 'app-fleet-header',
  templateUrl: './fleet-header.component.html',
  styleUrls: ['./fleet-header.component.scss']
})
export class FleetHeaderComponent implements OnInit, OnDestroy {
    @Input() isMaster: any;
    @Input() loginName: any;
    @Output() toggleNav: EventEmitter<void> = new EventEmitter<void>();

    menu = false;
    submenu = '';
    userData: User = {} as User;
    avatarUrl: string;
    userDataSubscription: Subscription;
    selectedRole: Role;
    constructor(
        private bannerService: BannerService,
        private userService: UserService,
        private roleService: RoleService
    ) {}

    ngOnInit() {
        this.userDataSubscription = this.userService.getUserData().subscribe(
            userData => {
                this.userData = userData;
                this.avatarUrl = userData.avatarUrl || null;
            }
        );

        this.roleService.selectedUserRole$.subscribe((role: Role) => {
            if (UtilitiesService.isNotEmpty(role)) {
                this.selectedRole = role;
            } else {
                this.selectedRole = null;
            }
        });
    }

    ngOnDestroy() {
        this.userDataSubscription.unsubscribe();
    }
}
